import { useContext } from "react";

import { UserAttributionSettingsContext } from "./user-attribution-settings-context";

export const useUserAttributionSettings = () => {
  const context = useContext(UserAttributionSettingsContext);

  if (!context) {
    throw new Error(
      "useUserAttributionSettings can only be used inside UserAttributionSettingsContext",
    );
  }

  return context;
};
